import RequestDeleteButton from './request-delete-button'

export default RequestDeleteButton
